import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { Clickable } from "../../clickable";
/* This was originally added because the action buttons (clear and the toggle) sit on top of the real button element. If we don't add padding, long selections will appear underneath those buttons. */
var computeRightPadding = function computeRightPadding(props) {
  if (props.hideDropdownArrow && !props.isClearable) {
    return "0";
  } else if (props.hideDropdownArrow || !props.isClearable) {
    return "32px";
  } else {
    return "60px";
  }
};
export var SelectButton = styled(Clickable)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 0;\n    padding-left: ", ";\n    padding-right: ", ";\n    height: 40px;\n    width: 100%;\n\n    position: relative;\n    display: flex;\n    align-items: center;\n\n    border: 0px;\n    background-color: transparent;\n    cursor: inherit;\n    overflow-wrap: break-word;\n"])), function (props) {
  return props.hasContentBefore ? "0" : "12px";
}, computeRightPadding);
//# sourceMappingURL=SelectButton.js.map